<div class="modal-header">
  <h2>{{Circuito?.Titulo}}({{Circuito?.Fornecedor + "/" + Circuito?.CodigoCircuito}})</h2>
  <button type="button" class="close" [disabled]="carregando" aria-label="Close" (click)="fecharModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="col-sm-12 mb-2">
    <div class="row d-flex justify-content-center mt-5 p-2">
      <span class="col-md-2"><strong>{{"Duração"| translate}}: </strong>{{Circuito?.Duracao}}</span>
      <span class="col-md-3"><strong>{{"Inicio Em"| translate}}: </strong>{{Circuito?.CidadeInicio}}</span>
      <span class="col-md-3" *ngIf="Circuito?.Fornecedor != 'ST'"><strong>{{"Final Em"| translate}}: </strong>{{Circuito?.CidadeFim}}</span>
      <span class="col-md-2"><strong>{{"Check-In"| translate}}: </strong>{{Circuito?.CheckIn | date: 'dd/MM/yyyy'}}</span>
      <span
        class="col-md-2"><strong>{{"Check-Out"| translate}}: </strong>{{Circuito?.CheckOut | date: 'dd/MM/yyyy'}}</span>
    </div>
  </div>

  <div class="card-body table-full-width table-responsive">
    <div class="row mb-5 mt-5">
      <div class="col-sm-12 text-center">
        <h4 *ngIf="carregando">Efetuando cancelamento...</h4>
        <h4 *ngIf="cancelado">Circuito Cancelado com Sucesso!</h4>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="row col-md-12">
      <button *ngIf="!carregando && !cancelado" (click)="cancelar()" class="btn btn-warning"
        type="submit">{{'Cancelar' | translate}}</button>
    </div>

    <div *ngIf="mensagemSucesso || mensagensErro" class="row col-md-12">
      <div class="col-md-12 mt-3" *ngIf="mensagemSucesso">
        <nb-alert status="success" (close)="limparMensagens()" closable>{{mensagemSucesso | translate}}</nb-alert>
      </div>
      <div class="col-md-12 mt-3" *ngIf="mensagensErro">
        <nb-alert status="danger" closable (close)="limparMensagens()">
          <ul>
            <li *ngFor="let m of mensagensErro">
              {{m | translate}}
            </li>
          </ul>
        </nb-alert>
      </div>
    </div>

  </div>
</div>

